import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import { createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";

import { connect } from "react-redux";

import ReactTable from "react-table";

import loaderIcon from "assets/img/loader.gif";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import IconButton from "@material-ui/core/IconButton";
import green from "@material-ui/core/colors/green";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";

// import VisibilityIcon from "@material-ui/icons/Visibility";

import DeleteModel from "components/Common/FevoModels/DeleteModel";

import axios from "../../../config/axios";

import toastr from "toastr";

import { getAllFaq$ } from "../../../redux/actions/cms";

const formStyle = {
  minWidth: "100%",
  margin: "0 1.2rem 1.2rem 0"
};

class ManageFAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
      faqDeletedIndex: null,
      faqTobeDeleted: null,
      showDeleteFaqModal: false
    };
  }

  componentDidMount() {
    this.props.handleGetFaqList();
  }

  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green
      }
    });
    let column = [
      {
        Header: "Title",
        accessor: "title"
      },
      {
        Header: "Question",
        accessor: "question"
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: faq => {
          return (
            <div className="actions-center">
              <Tooltip title="View">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    this.props.history.push("/admin/view-faq", {
                      action: "view",
                      faq: faq.original
                    });
                  }}
                >
                  <Icon>visibility_icon</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    this.props.history.push("/admin/edit-faq", {
                      action: "edit",
                      faq: faq.original
                    });
                  }}
                >
                  <Icon>edit_icon</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete FAQ">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    this.handleFaqDeleteChange(faq.original, faq.index);
                  }}
                >
                  <Icon>delete_icon</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        }
      }
    ];
    return column;
  };

  handleFaqDeleteChange = (faqTobeDeleted, faqDeletedIndex) => {
    this.setState({
      faqDeletedIndex,
      faqTobeDeleted,
      showDeleteFaqModal: true
    });
  };

  deleteFaq = (faq, index) => {
    axios
      .delete(`faqs/${faq.id}`)
      .then(res => {
        if (res.status === 200) {
          toastr.success("FAQ Deleted Successfully!");
          this.handleDeleteModal();
          this.props.handleGetFaqList();
        }
      })
      .catch(error => toastr.error("Something wrong happened!"));
  };

  handleDeleteModal = () => {
    this.setState(({ showDeleteFaqModal }) => ({
      showDeleteFaqModal: !showDeleteFaqModal,
      faqDeletedIndex: null,
      faqTobeDeleted: null
    }));
  };

  render() {
    const { showDeleteFaqModal } = this.state;
    const { faqListData } = this.props;
    const { loading, data } = faqListData;
    return (
      <div>
        {loading ? (
          <div className="loader_icon">
            <img src={loaderIcon} />
          </div>
        ) : (
          <div>
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardBody>
                    <ReactTable
                      data={data}
                      loading={loading}
                      columns={this.getUserTableColumn()}
                      defaultPageSize={20}
                      pageSizeOptions={[5, 10, 20, 25, 50]}
                      showPaginationBottom={true}
                      minRows={0}
                      noDataText="No FAQs found"
                      getTrProps={(state, rowInfo, column, instance) => {
                        return {
                          onClick: (e, handleOriginal) => {
                            if (rowInfo) {
                              // this.editCategoryFunc(rowInfo.original);
                            }
                          },
                          style: {
                            // textAlign: "center",
                            cursor: "pointer"
                          }
                        };
                      }}
                      getTheadThProps={(state, rowInfo, column, instance) => {
                        return {
                          style: {
                            marginBottom: "13px"
                          }
                        };
                      }}
                    />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
            <DeleteModel
              showModel={showDeleteFaqModal}
              title={"Are you sure you want to delete this faq?"}
              onCancel={this.handleDeleteModal}
              onOk={() => {
                let { faqDeletedIndex, faqTobeDeleted } = this.state;
                this.deleteFaq(faqTobeDeleted, faqDeletedIndex);
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    faqListData: state.cms.faq
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleGetFaqList: () => dispatch(getAllFaq$.trigger())
  };
};

const ManageFAQComponent = withStyles(extendedTablesStyle)(ManageFAQ);
export default connect(mapStateToProps, mapDispatchToProps)(ManageFAQComponent);



// WEBPACK FOOTER //
// ./src/views/ISEAS/ContentBuilder/ManageFAQ.js